import { Build, Component, Element, h, Host, Listen, Prop, State } from '@stencil/core';

@Component({
  tag: 'mama-gallery',
  styleUrl: './mama-gallery.scss',
})
export class MamaGallery {
  protected items = [];
  protected activeSlideIndex: number;

  @Element() el!: HTMLElement;
  @Prop() layerText: string = '';
  @State() modalElement: HTMLElement = null;

  componentDidLoad() {
    this.items = Array.from(this.el.querySelectorAll('mama-gallery-item'));
    this.items.forEach((item, index) => {
      item.setAttribute('layer-headline', `${this.items.length - index}+`);
      item.setAttribute('layer-text', this.layerText);
    });
  }

  @Listen('keyup', { target: 'window' })
  onClick(event: KeyboardEvent) {
    if (event.key.toLowerCase() === 'escape') {
      this.closeModal();
    }
  }

  @Listen('mamaGalleryItemClicked')
  openModal(event: CustomEvent) {
    this.modalElement = event.target as HTMLElement;
    this.setActiveSliderIndex(event.target as HTMLElement);
  }

  closeModal() {
    this.modalElement = null;
  }

  setActiveSliderIndex(clickedItem: HTMLElement) {
    this.activeSlideIndex = this.items.indexOf(clickedItem);
  }

  renderModal() {
    if (this.modalElement == null || Build.isServer) {
      return;
    }
    return (
      <div class="modal-backdrop fade" onClick={() => this.closeModal()}>
        <div class="modal">
          <div class="modal-dialog" onClick={e => e.stopPropagation()}>
            <div class="modal-content">
              <svg class="times" data-dismiss="modal" aria-label="Close" onClick={() => this.closeModal()}>
                <use xlinkHref="#times"></use>
              </svg>
              <mama-gallery-slider active-slide-index={this.activeSlideIndex}>
                {(this.items || []).map(item => (
                  <div class="swiper-slide" innerHTML={item.innerHTML} />
                ))}
              </mama-gallery-slider>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Host>
        <slot />
        {this.renderModal()}
      </Host>
    );
  }
}
